var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileNotch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 440H144C139.594 440 136 443.578 136 448S139.594 456 144 456H240C244.406 456 248 452.422 248 448S244.406 440 240 440ZM304 0H80C53.5 0 32 21.5 32 48V464C32 490.5 53.5 512 80 512H304C330.5 512 352 490.5 352 464V48C352 21.5 330.5 0 304 0ZM144 16H240V40C240 44.406 236.406 48 232 48H152C147.594 48 144 44.406 144 40V16ZM336 464C336 481.645 321.645 496 304 496H80C62.355 496 48 481.645 48 464V48C48 30.355 62.355 16 80 16H128V40C128 53.234 138.766 64 152 64H232C245.234 64 256 53.234 256 40V16H304C321.645 16 336 30.355 336 48V464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNotch);
export default __webpack_public_path__ + "static/media/mobile-notch.edd1ec316e572180795598524887b07c.svg";
export { ForwardRef as ReactComponent };